import React from 'react';
import PropTypes from 'prop-types';

import { getColorHex, getSwatchImage } from '../../Utils/SwatchUtils';
import { IconCrossedout } from '../Icons';
import { StyledLabel } from './RadioSwatchStyles';

var _ref = React.createElement(IconCrossedout, null);

var RadioSwatch = function RadioSwatch(props) {
  var hexValue = getColorHex(props.value.toLowerCase());
  var useSwatchImage = !hexValue;

  return React.createElement(
    StyledLabel,
    {
      hexValue: hexValue,
      htmlFor: props.htmlFor,
      active: props.active
    },
    useSwatchImage && React.createElement('img', { src: getSwatchImage(props.value), alt: props.value }),
    !props.optionAvailable && _ref
  );
};

RadioSwatch.propTypes = {
  value: PropTypes.string.isRequired,
  active: PropTypes.bool.isRequired,
  optionAvailable: PropTypes.bool,
  htmlFor: PropTypes.string
};

export default React.memo(RadioSwatch);